<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 出入记录 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 200px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="记录类型">
          <el-select
            v-model="formInline.inventoryType"
            @change="queryClick"
            style="width: 200px"
            placeholder="记录类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="库存-入库" value="stock_inbound"></el-option>
            <el-option label="库存-出库" value="stock_outbound"></el-option>
            <el-option label="库存-拆零" value="stock_split"></el-option>
            <el-option label="库存-盘点" value="stock_sheet"></el-option>
            <el-option label="订单-售出" value="order_sale"></el-option>
            <el-option label="订单-退货" value="order_return"></el-option>
            <el-option label="采购-入库" value="purchase_inbound"></el-option>
            <el-option label="补货-入库" value="replenish_inbound"></el-option>
            <el-option label="调货-出库" value="replenish_outbound"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="出库渠道"
          v-if="storeGuid && formInline.inventoryType == 'stock_outbound'"
        >
          <customer-outbound-channel-select
            style="width: 200px"
            v-model="formInline.channelGuid"
            @change="queryClick"
            :storeGuid="storeGuid"
            placeholder="出库渠道"
          />
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            style="width: 240px"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 10px">
        <time-range @change="handleTimeChange" style="margin-bottom: 10px" />
        <div v-if="storeGuid && times">
          <x-table
            ref="list"
            listApi="biz.warehouse.inventory.info.list"
            paginationLayout="total, sizes, prev, next, jumper"
            actionFixed="right"
            emptyLabel="暂无库存记录信息"
            :fieldList="fieldList"
            :actionList="actionList"
            :defaultParams="defaultParams"
            :actionWidth="220"
          >
            <template slot="row-info" slot-scope="scope">
              <warehouse-inventory-info :inventoryInfo="scope.row" />
            </template>
          </x-table>
        </div>
        <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
      </div>
    </el-card>
    <el-dialog
      title="提示"
      append-to-body
      :show-close="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible="printLoading"
      width="400px"
    >
      <span>
        <i class="el-icon-loading"></i>
        正在打印中
      </span>
    </el-dialog>
  </div>
</template>

<script>
import timeRange from "../../../../components/timeRange.vue";
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import warehouseInventoryInfo from "../../../../components/business/warehouseInventoryInfo.vue";
import customerOutboundChannelSelect from "../../../../components/business/customerOutboundChannelSelect.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import inventoryDetailPage from "./detail.vue";

export default {
  components: {
    goodsSkuInfo,
    customerOutboundChannelSelect,
    warehouseInventoryInfo,
    customerStoreSelect,
    timeRange,
  },
  props: {
    tabName: {
      type: String,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          storeGuid: this.storeGuid,
          orderGuid: this.pageQuery.orderGuid,
        },
        this.queryModel || {},
        this.times
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    },
  },
  methods: {
    clearClick() {
      this.formInline = {
        channelGuid: "",
        supplierGuid: "",
        inventoryType: "",
        queryValue: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      if (this.formInline.inventoryType != "stock_inbound") {
        this.formInline.supplierGuid = "";
      } else if (this.formInline.inventoryType != "stock_outbound") {
        this.formInline.channelGuid = "";
      }
      this.queryModel = Object.assign({}, this.formInline);
    },
    handleTimeChange(time) {
      this.times = time;
    },
  },
  data() {
    return {
      times: null,
      storeGuid: "",
      printLoading: false,
      queryModel: {},
      formInline: {
        channelGuid: "",
        supplierGuid: "",
        inventoryType: "",
        queryValue: "",
      },
      fieldList: [
        {
          label: "记录信息",
          minWidth: "280",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              refresh,
              title: "库存记录详情",
              component: inventoryDetailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "打印单据",
          disabled: (row) => {
            return row.optCancel != 0;
          },
          click: (row, tag, refresh) => {
            this.printInventory(row);
          },
        },
      ],
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
  },
};
</script>
